module.exports = __webpack_public_path__ + "static/media/fa-light-300.3645a24c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-light-300.ttf
// module id = 735
// module chunks = 0